import React from 'react';
import { useGetCertificatesQuery, useDownloadCertificateMutation } from '../../features/courses/coursesAPI';
import CertificateCard from '../../components/CertificateCard';

const CertificatePage = () => {
    const { data: certificates = [], isLoading } = useGetCertificatesQuery();
    const [downloadCertificate] = useDownloadCertificateMutation();

    // Calculate course completion status (percentage)
    const calculateCompletion = (completedLessons, totalLessons) => {
        if (totalLessons === 0) return 0;
        return Math.round((completedLessons / totalLessons) * 100);
    };

    const handleDownload = async (id) => {
        try {
            const blob = await downloadCertificate(id).unwrap();
            const url = window.URL.createObjectURL(new Blob([blob]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `certificate_${id}.pdf`);
            document.body.appendChild(link);
            link.click();
            link.remove();

            console.log(blob.data.id)
        } catch (error) {
            console.error('Download failed:', error);
        }
    };

    if (isLoading) return <p className="p-4">Loading certificates...</p>;

    return (
        <div className="max-w-4xl mx-auto py-6">
            <h1 className="text-2xl font-bold mb-6">Your Certificates</h1>
            {certificates.length > 0 ? (
                certificates.map((item, index) => {
                    const course = item?.course;
                    const completedLessons = item?.enrollment?.completed_lessons || 0;
                    const totalLessons = course?.lessons?.length || 0;
                    const completionPercentage = calculateCompletion(completedLessons, totalLessons);

                    const uniqueKey = item?.enrollment_item_id || `${item?.course_id}_${index}`;
                    return (
                        <div key={uniqueKey} className="mb-6">
                            <CertificateCard 
                                item={item}
                                onDownload={handleDownload}
                                completionPercentage={completionPercentage}
                            />
                        </div>
                    );
                })
            ) : (
                <p>No certificates available.</p>
            )}
        </div>
    );
};

export default CertificatePage;
